import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

const PassesPurchaseStatusDropdown = (props) => {
    const { onChange, value, multiple, classN, req, id, disabled } = props;
    const { t } = useTranslation();

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {t(`passes.purchasedPassesStatus${multiple ? "es" : ""}`)} {req && <span className="text-danger">*</span>}
                </Form.Label>

                <Dropdown
                    placeholder={multiple ? t("chooseMany") : t("choose")}
                    fluid
                    multiple={multiple}
                    selection
                    options={
                        multiple
                            ? [
                                  {
                                      key: 0,
                                      value: "not-paid",
                                      text: t("notPaid"),
                                  },
                                  {
                                      key: 1,
                                      value: "not-fully-paid",
                                      text: t("notFullyPaid"),
                                  },
                                  {
                                      key: 2,
                                      value: "paid",
                                      text: t("paid"),
                                  },
                              ]
                            : [
                                  {
                                      key: 0,
                                      value: "default",
                                      text: t("all"),
                                  },
                                  {
                                      key: 1,
                                      value: "not-paid",
                                      text: t("notPaid"),
                                  },
                                  {
                                      key: 2,
                                      value: "not-fully-paid",
                                      text: t("notFullyPaid"),
                                  },
                                  {
                                      key: 3,
                                      value: "paid",
                                      text: t("paid"),
                                  },
                              ]
                    }
                    onChange={(e, data) => onChange(data.value)}
                    value={value}
                    id={id}
                    disabled={disabled}
                />
            </Form.Group>
        </Fragment>
    );
};

export default PassesPurchaseStatusDropdown;
